import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavbarChildrenVisibilityService {
  private visibilityConfig = new BehaviorSubject<Map<string, boolean>>(new Map());
  
  visibilityConfig$: Observable<Map<string, boolean>> = this.visibilityConfig.asObservable();

  setChildrenVisibility(product: string, showChildren: boolean): void {
    const currentConfig = this.visibilityConfig.getValue();
    currentConfig.set(product, showChildren);
    this.visibilityConfig.next(new Map(currentConfig));
  }

  shouldShowChildren(product: string): boolean {
    const config = this.visibilityConfig.getValue();
    if (!config.has(product)) {
      return true;
    }
    return config.get(product);
  }

  isConfigured(product: string): boolean {
    return this.visibilityConfig.getValue().has(product);
  }

  resetVisibility(product: string): void {
    const currentConfig = this.visibilityConfig.getValue();
    currentConfig.delete(product);
    this.visibilityConfig.next(new Map(currentConfig));
  }
}
